"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ramda = require("ramda");

var _sanitizeHtml = _interopRequireDefault(require("sanitize-html"));

var SUPPORTED_SANITIZER_OPTIONS = ['allowProtocolRelative', 'allowedAttributes', 'allowedClasses', 'allowedSchemes', 'allowedSchemesByTag', 'allowedTags', 'exclusiveFilter', 'nonTextTags', 'parser', 'selfClosing', 'transformTags'];
var pickNotNil = (0, _ramda.pickBy)((0, _ramda.complement)(_ramda.isNil));
/**
 * Wrapper component for sanitize-html library.
 *
 *
 * @param {ISanitizedHTMLProps} props
 * @returns {ReactElement}
 */

var SanitizedHTML = function SanitizedHTML(props) {
  var id = props.id,
      style = props.style,
      className = props.className;
  var sanitizedHTML = (0, _react.useMemo)(function () {
    var sanitizerOptions = (0, _ramda.pipe)((0, _ramda.pick)(SUPPORTED_SANITIZER_OPTIONS), pickNotNil)(props);
    return (0, _sanitizeHtml["default"])(props.html, sanitizerOptions);
  }, [props]); // eslint-disable-next-line react/no-danger

  return /*#__PURE__*/_react["default"].createElement("div", {
    id: id,
    className: className,
    style: style,
    dangerouslySetInnerHTML: {
      __html: sanitizedHTML
    }
  });
};

var _default = SanitizedHTML;
exports["default"] = _default;